import { render, staticRenderFns } from "./Pfa.vue?vue&type=template&id=93335dfc&scoped=true"
import script from "./Pfa.vue?vue&type=script&lang=js"
export * from "./Pfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93335dfc",
  null
  
)

export default component.exports